import React from 'react';
import { Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { FIRMWARE_STATUS } from './constants';
import { formatAddress, formatDateTime, formatModuleFirmware, formatResource, formatValue } from './utils';

const STATUS_ICONS = {
  latest: <CheckCircleIcon className="!w-4 !h-4" />,
  outdated: <WarningAmberIcon className="!w-4 !h-4" />,
  unknown: <HelpOutlineIcon className="!w-4 !h-4" />,
};

const SerialOtaLink = (serialNumber) => {
  if (!serialNumber) return '-';

  const params = new URLSearchParams({ serial_number: serialNumber });

  return (
    <Link to={`/ota-events?${params}`} title="Журнал OTA-событий" className="text-orange-500 hover:underline whitespace-nowrap">
      {serialNumber}
    </Link>
  );
};

const FirmwareStatusBadge = (value) => {
  const meta = FIRMWARE_STATUS[value];
  if (!meta) return formatValue(value);

  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-sm font-medium ${meta.className}`}>
      {STATUS_ICONS[value]}
      {meta.label}
    </span>
  );
};

const ModulesCell = (modules) => {
  if (!Array.isArray(modules) || !modules.length) return '-';

  return (
    <div className="flex flex-col gap-2 min-w-[180px]">
      {modules.map((module, index) => {
        const title = [module?.kind, module?.key].filter(Boolean).join(' · ');
        const firmware = formatModuleFirmware(module?.firmware);

        return (
          <div key={`${module?.key || 'module'}-${index}`}>
            <div className="font-medium">{title || '-'}</div>
            {module?.radio_identity ? <div className="text-gray-500">{module.radio_identity}</div> : null}
            {firmware ? <div className="text-gray-600">{firmware}</div> : null}
            {module?.bound_at ? <div className="text-xs text-gray-400">с {formatDateTime(module.bound_at)}</div> : null}
          </div>
        );
      })}
    </div>
  );
};

export const getMetronDeviceColumns = () => [
  { key: 'serial_number', title: 'Заводской номер', sortable: true, render: SerialOtaLink },
  { key: 'resource', title: 'Ресурс', render: formatResource },
  {
    key: 'address',
    title: 'Адрес',
    render: (value, row) => <div className="min-w-[180px]">{formatAddress(value, row?.apartment)}</div>,
  },
  {
    key: 'user_email',
    title: 'Владелец',
    render: (value, row) => <div className="min-w-max">{value || (row?.user_id ? `ID ${row.user_id}` : '-')}</div>,
  },
  {
    key: 'nrf_firmware',
    title: 'nRF',
    hint: 'Прошивка BLE-модуля',
    sortable: true,
    render: formatValue,
  },
  {
    key: 'msp430_firmware',
    title: 'MSP430',
    hint: 'Прошивка счётчика',
    sortable: true,
    render: formatValue,
  },
  {
    key: 'firmware_status',
    title: 'Статус',
    hint: 'Считается относительно старшей версии в боевом канале',
    render: FirmwareStatusBadge,
  },
  { key: 'modules', title: 'Модули', hint: 'Установленные модули', render: ModulesCell },
  { key: 'last_reading_at', title: 'Последнее показание', sortable: true, render: formatDateTime },
  { key: 'created_at', title: 'Создан', sortable: true, render: formatDateTime },
];
